
import { clearAuthorization, clearBossToken, setAuthorization, setBossToken } from '@/axios/userInfo'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'



const token = {
"authToken": "102319a8-1d10-40cd-9133-69f005eca7c2",
"bossToken": "P8f7c780b892bbbe5c99fae8c6f7afd99"
}

export default {
name:'token-button',
components: {
InlineXSwitch
},
data () {
let localStorageKey = 'mylink_token_switch'
return {
localStorageKey,
authToken: token.authToken,
bossToken: token.bossToken,
hasSetToken: !!this.getItem(localStorageKey) || false,
flags: false,
position: { x: 0, y: 0 },
nx: '',
ny: '',
dx: '',
dy: '',
xPum: '',
yPum: ''
}
},
created () {
this.triggerToken()
},
methods: {

down (event) {
let _div = event.currentTarget
let touch
this.flags = true
if (event.touches) {
touch = event.touches[0]
} else {
touch = event
}
this.position.x = touch.clientX
this.position.y = touch.clientY
this.dx = _div.offsetLeft
this.dy = _div.offsetTop
},
move () {
let _div = event.currentTarget
let touch
if (this.flags) {
if (event.touches) {
touch = event.touches[0]
} else {
touch = event
}
this.nx = touch.clientX - this.position.x
this.ny = touch.clientY - this.position.y
this.xPum = this.dx + this.nx
this.yPum = this.dy + this.ny
_div.style.left = this.xPum + 'px'
_div.style.top = this.yPum + 'px'
}
},
end () {
this.flags = false
},

triggerToken () {
if (this.hasSetToken) {
setAuthorization(this.authToken)
setBossToken(this.bossToken)
this.setItem(this.localStorageKey, '1')
} else {
clearAuthorization()
clearBossToken()
this.setItem(this.localStorageKey, '')
}
},

getItem (key) {
if (window.localStorage) {
return window.localStorage.getItem(key)
}
return ''
},
setItem (key, val) {
if (window.localStorage) {
window.localStorage.setItem(key, val)
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/token-button/token-button.vue